export default "__VITE_ASSET__DvvU31BX__"